import { render, staticRenderFns } from "./TaskControls.vue?vue&type=template&id=5b7d4c8e&"
import script from "./TaskControls.vue?vue&type=script&lang=js&"
export * from "./TaskControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports